import { arrayField } from "@common";
import * as cn from "classnames";
import * as React from "react";
import { FieldError } from "../ErrorMessage";
import { AgeMapping } from "@store";
import { PremiumFeatureIcon } from "../PremiumFeatureIcon";

export interface AgeComponentProps {
    value: string[] | null;
    field: any | null;
    onChange: { events: any };
    isDisabled: boolean;
    onCheckBoxAction: (fieldName: string) => void;
    ageMapping: AgeMapping[];
    // Other props here
}

export interface AgeComponentState {
    isHintShown: boolean;
}

export class AgeComponent extends React.Component<AgeComponentProps, AgeComponentState> {
    constructor(props: AgeComponentProps) {
        super(props);
        this.state = {
            isHintShown: false
        };
    }

    handleChange(e: any, field: any, events: any, value: string) {
        const checkboxesWithoutUnknown = this.props.value.filter(v => v !== "Unknown");
        if (checkboxesWithoutUnknown.length === 1 && value !== "Unknown" && value === checkboxesWithoutUnknown[0]) {
            return this.showHint();
        }
        if (value === "Unknown") {
            return arrayField.toCheckbox.events(field, events, value).onChange(e, true);
        }
        arrayField.toCheckbox.events(field, events, value).onChange(e);
    }

    showHint() {
        this.setState({
            ...this.state,
            isHintShown: true
        });
        setTimeout(
            () =>
                this.setState({
                    ...this.state,
                    isHintShown: false
                }),
            2000
        );
    }

    render() {
        const { field, onChange, isDisabled, onCheckBoxAction, ageMapping } = this.props;
        const { isHintShown } = this.state;

        return (
            <>
                <div className="premium-block-wrapper">
                    <label className="common-checkbox custom-premium-checkbox tour-campaign-age-targeting">
                        <input
                            type="checkbox"
                            name="Enable Age Targeting"
                            value="age"
                            id=""
                            checked={!isDisabled}
                            onChange={e => onCheckBoxAction(e.target.value)}
                        />
                        Enable Age Targeting
                        <span className="checkmark" />
                    </label>
                    <PremiumFeatureIcon status="trial" />
                </div>
                <div className={cn("sub-check-boxes-wrapper strict__checkbox-wrapper", field.visualState)}>
                    {ageMapping &&
                        ageMapping.map((age: AgeMapping, index: number) => (
                            <label
                                key={index}
                                className={cn(
                                    "common-checkbox custom-age-checkbox strict__checkbox",
                                    isDisabled ? "common-checkbox__isDisabled" : "",
                                    age.type === "Unknown" ? "targeting__checkbox_strict" : ""
                                )}
                            >
                                <input
                                    type="checkbox"
                                    name="age"
                                    value={age.type}
                                    id=""
                                    checked={
                                        isDisabled
                                            ? false
                                            : age.type === "Unknown"
                                                ? !arrayField.toCheckbox.checked(field, age.type)
                                                : arrayField.toCheckbox.checked(field, age.type)
                                    }
                                    onChange={e => this.handleChange(e, field, onChange.events, age.type)}
                                    disabled={isDisabled}
                                />
                                {age.type === "Unknown" ? "Use strict targeting" : age.type}
                                <span className="checkmark" />
                            </label>
                        ))}
                </div>
                <FieldError field={field} />
                <span className={cn(`targeting__hint`, isHintShown ? "targeting__hint_visible" : "")}>
                    At least one targeting option must be selected
                </span>
            </>
        );
    }
}
